import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";

const ProtectedRoute = ({ children }) => {
  const { userAccessToken } = useSelector((state) => state.auth);
  const location = useLocation();

  const is_reg_complete = localStorage.getItem("is_reg_completed") === "true";

  // Not logged in
  if (!userAccessToken) {
    return <Navigate to="/" replace />;
  }

  // If registration completed AND trying to open setup page
  if (is_reg_complete && location.pathname === "/set-up") {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
};

export default ProtectedRoute;
